import React from 'react';
import Icon from './Icon';
import { CLOUD_PLATFORMS } from '../data/content';

export default function CloudPlatforms() {
  return (
    <section className="section section-alt partners-section">
      <div className="container">
        <div className="section-header reveal">
          <span className="eyebrow">Cloud Platforms</span>
          <h2 className="section-title">We Work With Best-in-Class Cloud Platforms</h2>
        </div>

        <div className="partners-grid reveal">
          {CLOUD_PLATFORMS.map((p) => (
            <div className="partner-badge" key={p}>
              <Icon name="building" size={18} />
              <span>{p}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}